<template>
  <div class="home-container">

  </div>
</template>

<script>
export default {
  name: 'ide'
}
</script>
